/**
 * snakeCaseToPascalCase("in_processing") -> "In Processing"
 *
 * @param  { String } text
 * @return String
 */
export function snakeCaseToPascalCase(text) {
  return text
    .split("_")
    .join(" ")
    .replace(/\w+/g, string => {
      return `${string[0].toUpperCase()}${string.slice(1).toLowerCase()}`;
    });
}

/**
 * pascalCaseToSnakeCase("Red Plum Bella") -> "red_plum_bella"
 *
 * @param  { String } text
 * @return String
 */
export function pascalCaseToSnakeCase(text) {
  return text
    .toLocaleLowerCase()
    .split(" ")
    .join("_");
}

/**
 * capitaLetter("SAVED Men's Cotton TANK") -> "Saved Men's Cotton Tank"
 *
 * @param  { String } text
 * @return String
 */
export function capitaLetter(text) {
  const original = text.toLowerCase().split(/\s+/);
  let modified = [];

  for (let i = 0; i < original.length; i++) {
    modified.push(original[i].charAt(0).toUpperCase() + original[i].slice(1));
  }
  return modified.join(" ");
}

/**
 * toHyphenCase("Top Product Picks") -> "top-product-picks"
 *
 * @param  { String } text
 * @return String
 */
export function toHyphenCase(text) {
  return text
    .toLowerCase()
    .split(" ")
    .join("-");
}

/**
 * hyphenCaseToPascalCase("top-product-picks") -> "Top Product Picks"
 *
 * @param  { String } text
 * @return String
 */
export function hyphenCaseToPascalCase(text) {
  if (text) {
    return text
      .toString()
      .split("-")
      .join(" ")
      .replace(/\w[`"]+/g, string => {
        return `${string[0].toUpperCase()}${string.slice(1).toLowerCase()}`;
      });
  }
}

/**
 * pluralize(1, 'turtle') -> "turtle"
 * pluralize(2, 'turtle') -> "turtles"
 * pluralize(3, 'fox', 'es') -> "foxes"
 *
 * This obviously doesn't support all english edge-cases, but it's suitable for most purposes
 *
 * @param  { String } count
 * @param  { String } noun
 * @param  { String } suffix
 * @returns String
 */
export function pluralize(count, noun, suffix = "s") {
  return `${noun}${![0, 1].includes(count) ? suffix : ""}`;
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/string.js